export { OwlDialogModule } from './dialog.module';
export { OwlDialogService } from './dialog.service';
export { OwlDialogRef } from './dialog-ref.class';



//////////////////
// WEBPACK FOOTER
// ./node_modules/ng-pick-datetime/dialog/index.js
// module id = ./node_modules/ng-pick-datetime/dialog/index.js
// module chunks = vendor